import _extends from "@babel/runtime/helpers/extends";
import React, { createContext, useContext, useMemo, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { tombac } from '../../shared';
import { Toast } from './Toast';
const ToastsContext = /*#__PURE__*/createContext(new Proxy({}, {
  get() {
    throw new Error('Toasts context not found! Use the ToastsProvider component.');
  }
}));
export const ToastsConsumer = ToastsContext.Consumer;
export function useToasts() {
  return useContext(ToastsContext);
}
const ListContainer = styled.div.withConfig({
  displayName: "ToastsContext__ListContainer"
})(["all:initial;display:flex;flex-direction:column-reverse;padding:", ";position:fixed;width:", ";z-index:", ";", ""], tombac.space(0, 2, 1), tombac.unit(432), _ref => {
  let {
    zIndex
  } = _ref;
  return zIndex;
}, _ref2 => {
  let {
    placement,
    topOffset
  } = _ref2;
  const attrs = placement.split('-');
  return css(["align-items:", ";", ":", ";", ":0;"], attrs[1] === 'left' ? 'flex-start' : 'flex-end', attrs[0], attrs[0] === 'top' && topOffset === 'navbar' ? tombac.unit(80) : 0, attrs[1]);
});
const ToastList = _ref3 => {
  let {
    onChange,
    placement,
    toasts,
    topOffset,
    zIndex
  } = _ref3;
  return /*#__PURE__*/React.createElement(ListContainer, {
    topOffset: topOffset,
    placement: placement,
    zIndex: zIndex
  }, toasts.map(t => /*#__PURE__*/React.createElement(Toast, _extends({
    key: t.id
  }, t, {
    onDissmised: () => onChange(toasts.filter(i => i.id !== t.id))
  }))));
};
export const ToastsProvider = _ref4 => {
  let {
    children,
    topOffset,
    zIndex
  } = _ref4;
  const [toasts, setToasts] = useState({});
  const idRef = useRef(0);
  const api = useMemo(() => ({
    addToast(message) {
      let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
      let {
        placement = 'top-right',
        ...options
      } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      setToasts(toasts => {
        var _toasts$placement, _options$id;
        const cornerToasts = (_toasts$placement = toasts[placement]) !== null && _toasts$placement !== void 0 ? _toasts$placement : [];
        if (options.id !== undefined && cornerToasts.find(t => t.id === options.id)) return toasts;
        idRef.current++;
        return {
          ...toasts,
          [placement]: cornerToasts.concat({
            id: (_options$id = options.id) !== null && _options$id !== void 0 ? _options$id : idRef.current.toString(),
            message,
            options: {
              placement,
              ...options
            },
            type
          })
        };
      });
    },
    dismissToast(id) {
      setToasts(toasts => {
        const newToasts = {};
        for (const [placement, cornerToasts] of Object.entries(toasts)) {
          const index = cornerToasts.findIndex(t => t.id === id);
          if (index !== -1) {
            newToasts[placement] = [...cornerToasts];
            newToasts[placement][index] = {
              ...cornerToasts[index],
              dismissRequested: true
            };
          } else {
            newToasts[placement] = cornerToasts;
          }
        }
        return newToasts;
      });
    }
  }), []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, Object.keys(toasts).map(placement => /*#__PURE__*/React.createElement(ToastList, {
    key: placement,
    placement: placement,
    onChange: cornerToasts => setToasts({
      ...toasts,
      [placement]: cornerToasts
    }),
    toasts: toasts[placement],
    topOffset: topOffset,
    zIndex: zIndex
  })), /*#__PURE__*/React.createElement(ToastsContext.Provider, {
    value: api
  }, children));
};
//# sourceMappingURL=ToastsContext.js.map